// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__b6b0y","invalid":"Checkbox_invalid__cGGMH"};